// Shared client-side helpers for the registration rate limit (used by BOTH
// the one-click flow in login-popup and the standard form in register-popup).
// Both popups persist the same two localStorage keys so a 429 in either flow
// blocks both until retryAt.
import { LocalStoreService } from './local-store.service';

export const REGISTRATION_DEVICE_ID_KEY = 'racebet_registration_device_id';
export const REGISTRATION_RETRY_AT_KEY = 'racebet_registration_retry_at';

export function generateUuidV4(): string {
  const cryptoObj: any = typeof crypto !== 'undefined' ? crypto : null;
  if (cryptoObj && typeof cryptoObj.randomUUID === 'function') {
    return cryptoObj.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// Returns the persistent browser id, minting one on first use. SSR-safe:
// returns null on the server (LocalStoreService no-ops there anyway).
export function ensureRegistrationDeviceId(
  store: LocalStoreService,
  isBrowser: boolean
): string | null {
  if (!isBrowser) {
    return null;
  }
  let id = store.getItem<string>(REGISTRATION_DEVICE_ID_KEY);
  if (!id) {
    id = generateUuidV4();
    store.setItem(REGISTRATION_DEVICE_ID_KEY, id);
  }
  return id;
}

export function isRegistrationLimitedError(err: any): boolean {
  const body = err && err.error;
  if (!body || typeof body !== 'object') {
    return false;
  }
  return (
    body.errorCode === 'REGISTRATION_TEMPORARILY_LIMITED' ||
    body.code === 'REGISTRATION_TEMPORARILY_LIMITED' ||
    err.status === 429
  );
}

// retryAt from the 429 metadata; falls back to +1h (the backend window).
export function registrationRetryAtFromError(err: any): string {
  const body = err && err.error;
  return (
    (body && body.metadata && body.metadata.retryAt) ||
    new Date(Date.now() + 60 * 60 * 1000).toISOString()
  );
}
